<script>
import { useAlert } from 'dashboard/composables';

  export default {
    name: "EditStatusModal",
    props: {
      booking: {
        type: Object,
        required: true
      }
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
      async handleSubmit() {
        try{
          if (!this.newStatus) {
            useAlert('Please select a status.');
            return;
          }
          this.isSubmitting = true;
          await this.$store.dispatch('rentalBranch/updateStatus', {
            booking_id: this.booking.booking_id,
            payload: { status: this.newStatus }
          });
          useAlert('Booking status updated successfully.');
          this.$emit('close');
          this.$emit('refresh');
        }catch(err){
          useAlert(err.message || 'Failed to update status.');
        }finally {
          this.isSubmitting = false;
        }
      }
    },
    data() {
      return {
        newStatus: '',
        isSubmitting: false,
        statusOptions: [
          { value: 'requested', label: 'Requested' },
          { value: 'confirmed', label: 'Confirmed' },
          { value: 'rescheduled', label: 'Rescheduled' },
          { value: 'cancelled', label: 'Cancelled' },
          { value: 'completed', label: 'Completed' },
        ],
      }
    },
    mounted() {
      this.newStatus = this.booking.status || '';
    }
  }
</script>

<template>
    <div class="z-50 fixed inset-0 flex items-center bg-slate-800/40 px-4">
      <div class="max-h-[80vh] overflow-y-auto mx-auto my-2 p-6 border-2 rounded-lg bg-white dark:bg-slate-800 shadow-xl min-w-[350px] w-full max-w-md relative">
        <button 
          @click="handleClose" 
          class="absolute top-2 right-2 text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 text-xl"
          > &times; </button>
        <h2 
          class="text-xl font-semibold mb-4 text-slate-900 dark:text-slate-100"
          >Edit Booking Status</h2>
        <div class="mb-4">
          <label for="status">New status:</label>
          <select
            id="status"
            v-model="newStatus"
          >
            <option v-for="option in statusOptions" :key="option.value" :value="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="flex justify-end mt-4">
          <button @click="handleSubmit" :disabled="isSubmitting" class="px-4 py-2 rounded bg-woot-500 text-white hover:bg-woot-600 disabled:opacity-60">
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
          </button>
        </div>
      </div>
    </div>
</template>